import { ModulesEnum } from '@/core/modulesEnum';
import { OfficeUtils } from '@/utils/office.utils';

/**
 * Service that determines which modules are available based on the current platform
 */
class ModuleAvailabilityService {
  /**
   * Returns an array of modules that are supported on the current platform
   */
  public getSupportedModules(): ModulesEnum[] {
    // Base modules available on all platforms
    const baseModules = [ModulesEnum.LEGAL_ASSISTANT];

    // Platform-specific modules
    if (!OfficeUtils.isOutlook()) {
      // Word-only modules
      return [...baseModules, ModulesEnum.DOC_REVIEWING];
    }

    // Return just the base modules for Outlook
    return baseModules;
  }
}

export default new ModuleAvailabilityService();
